<template>
    <div>
        <div class="image-upload" v-on:drop="dropHandler" v-on:dragover="hoverHandler" v-on:click="clickHandler">
            <button
                type="button"
                class="close"
                aria-label="Close"
                v-if="image && !hideRemoveButton"
                v-on:click="deleteClickHandler($event)"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <img v-if="image" :src="image" />
            <div class="no-image" v-if="!image">
                <div class="drop-zone">Drop an image here</div>
                <div class="click-bait">Click to browse</div>
            </div>
        </div>
        <div class="help" v-if="help">
            <span v-if="help.title" class="help-title">{{ help.title }}</span>
            <p class="help-paragraph" v-if="help.body" v-for="(paragraph) in help.body">{{paragraph}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageUpload',
    props: {
        help: Object,
        imageUrl: String,
        hideRemoveButton: Boolean,
    },
    methods: {
        hoverHandler(event) {
            event.preventDefault();
        },
        dropHandler(event) {
            event.preventDefault();

            // Check if files are dropped
            if (event.dataTransfer.items) {
                for (var i = 0; i < event.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (event.dataTransfer.items[i].kind === 'file') {
                        var file = event.dataTransfer.items[i].getAsFile();
                        this.$emit('image-loaded', file);
                        return;
                    }
                }
            }
        },
        clickHandler(event) {
            const input = document.createElement('input');
            input.type="file";
            input.onchange = (event) => {
                this.loadImage(event.target.files[0]);
            };
            input.click();
        },
        deleteClickHandler(event) {
            event.preventDefault();
            event.stopPropagation();
            this.$emit('image-removed', this.image);
        },
        loadImage(file) {
            this.image = URL.createObjectURL(file);
            this.$emit('image-loaded', file);
        },
    },
    data () {
        return {
            image: this.imageUrl,
        }
    }
};
</script>
